import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram, FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  background: #2c3e50;
  color: white;
  padding: 2.5rem 0 1rem;
  margin-top: auto;
`;

const FooterContent = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 1rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1.5rem;
`;

const FooterSection = styled.div`
  h3 {
    color: #3b82f6;
    margin-bottom: 0.75rem;
    font-size: 1.1rem;
    font-family: 'Inter', sans-serif;
    font-weight: 600;
  }
  
  p {
    line-height: 1.5;
    margin-bottom: 0.75rem;
    color: #bdc3c7;
    font-size: 0.9rem;
    font-family: 'Inter', sans-serif;
  }
  
  ul {
    list-style: none;
    padding: 0;
    
    li {
      margin-bottom: 0.4rem;
      
      a {
        color: #bdc3c7;
        text-decoration: none;
        transition: color 0.3s ease;
        font-size: 0.9rem;
        font-family: 'Inter', sans-serif;
        
        &:hover {
          color: #3b82f6;
        }
      }
    }
  }
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
  
  a {
    color: #bdc3c7;
    font-size: 1.5rem;
    transition: color 0.3s ease;
    
    &:hover {
      color: #3b82f6;
    }
  }
`;

const ContactInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
  color: #bdc3c7;
  
  svg {
    color: #3b82f6;
  }
`;

const FooterBottom = styled.div`
  border-top: 1px solid #34495e;
  margin-top: 2rem;
  padding-top: 1rem;
  text-align: center;
  color: #bdc3c7;
  
  p {
    margin: 0;
  }
`;

const Footer = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <FooterSection>
          <h3>About Cred Encuesta</h3>
          <p>
            Cred Encuesta is a global market research company providing high quality data collection services, superior 24/7 project management support, and accurate and timely data delivery. Through our proprietary panels, together with our select industry partners, we connect with over 8 million respondents in over 35 countries.
          </p>
          <SocialLinks>
            <a href="#" aria-label="Facebook">
              <FaFacebook />
            </a>
            <a href="#" aria-label="Twitter">
              <FaTwitter />
            </a>
            <a href="#" aria-label="LinkedIn">
              <FaLinkedin />
            </a>
            <a href="#" aria-label="Instagram">
              <FaInstagram />
            </a>
          </SocialLinks>
        </FooterSection>
        
        <FooterSection>
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/surveys">Available Surveys</Link></li>
            <li><Link to="/rewards">Rewards</Link></li>
            <li><Link to="/dashboard">Dashboard</Link></li>
            <li><a href="#">How It Works</a></li>
            <li><a href="#">FAQ</a></li>
          </ul>
        </FooterSection>
        
        <FooterSection>
          <h3>Support</h3>
          <ul>
            <li><a href="#">Help Center</a></li>
            <li><a href="#">Contact Support</a></li>
            <li><a href="#">Privacy Policy</a></li>
            <li><a href="#">Terms of Service</a></li>
            <li><a href="#">Cookie Policy</a></li>
            <li><a href="#">Community Guidelines</a></li>
          </ul>
        </FooterSection>
        
        <FooterSection>
          <h3>Contact Us</h3>
          <ContactInfo>
            <FaEnvelope />
            <span>business@credencuesta.com</span>
          </ContactInfo>
          <ContactInfo>
            <FaPhone />
            <span>+91-7982622067</span>
          </ContactInfo>
          <ContactInfo>
            <FaMapMarkerAlt />
            <span>Global Market Research Office, India</span>
          </ContactInfo>
          <p style={{ marginTop: '1rem', fontSize: '0.9rem' }}>
            Available 24/7 for support and assistance
          </p>
        </FooterSection>
      </FooterContent>
      
      <FooterBottom>
        <p>&copy; 2024 Cred Encuesta. All rights reserved. | Empowering voices worldwide.</p>
      </FooterBottom>
    </FooterContainer>
  );
};

export default Footer;